import React, { useContext, useEffect, useState } from "react";
import { Link, Navigate, Outlet } from "react-router-dom";
import { DContext } from "../context/Datacontext";
import LoginImage1 from "../assets/Auth1.jpg";
import LoginImage2 from "../assets/Auth2.jpg";
import LoginImage3 from "../assets/Auth3.jpg";

export const AuthLayout = () => {

  const { isAuth } = useContext(DContext);

  const slides = [
    { title: "Collaborate Better", desc: "Learn together, grow faster" },
    { title: "Learn Smarter", desc: "Modern LMS for future skills" },
    { title: "Upgrade Knowledge", desc: "Industry-ready courses" },
  ];

  const images = [
    LoginImage1,
    LoginImage2,
    LoginImage3,
  ];

  const [index, setIndex] = useState(0);
  const [paused, setPaused] = useState(false);

  //Preload images (prevents lag / blur)
  useEffect(() => {
    images.forEach((src) => {
      const img = new Image();
      img.src = src;
    });
  }, []);

  //Smooth auto slide (slower + premium feel)
  useEffect(() => {
    if (paused) return;

    const timer = setInterval(() => {
      setIndex((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
    }, 4000); // slower = smoother feel

    return () => clearInterval(timer);
  }, [paused, slides.length]);

  if (isAuth === null) return null;
  if (isAuth) return <Navigate to="/app/dashboard" replace />;

  return (
    <div className="h-screen flex items-center justify-center bg-primary-100 p-1 md:p-6">
      {/* MAIN WRAPPER */}
      <div className="w-full max-w-6xl h-[90vh] bg-gradient-to-r from-primary-50 to-secondary-100 rounded-3xl flex overflow-hidden gap-6 md:p-6 p-1">

        {/* LEFT IMAGE SECTION */}
        <div
          className="hidden md:flex w-1/2 h-full relative rounded-3xl overflow-hidden items-center justify-center"
          onMouseEnter={() => setPaused(true)}
          onMouseLeave={() => setPaused(false)}
        >

          {/* HOME BUTTON */}
          <Link
            to="/"
            className="absolute top-6 right-6 z-20 bg-secondary-200 text-secondary-700 backdrop-blur-md p-3 rounded-xl hover:bg-white/50 hover:scale-110 transition"
          >
            Home
          </Link>

          {/* ✅ SMOOTH IMAGE FADE SYSTEM */}
          {images.map((img, i) => (
            <img
              key={i}
              src={img}
              alt="Illustration"
              className={`absolute inset-0 w-full h-full object-cover 
              transition-all duration-[1200ms] ease-in-out
              ${i === index ? "opacity-100 scale-100" : "opacity-0 scale-105"}`}
            />
          ))}

          {/* DARK OVERLAY */}
          <div className="absolute inset-0 bg-black/30"></div>

          {/* SLIDE TEXT */}
          <div className="absolute bottom-20 w-full flex justify-center px-6 z-10">
            <div className="bg-white/15 backdrop-blur-md px-6 py-4 rounded-xl text-center max-w-sm">

              <h2 className="text-xl font-semibold text-white mb-2">
                {slides[index].title}
              </h2>

              <p className="text-sm text-white/90">
                {slides[index].desc}
              </p>

            </div>
          </div>

          {/* DOTS */}
          <div className="absolute bottom-6 w-full flex justify-center gap-3 z-10">
            {slides.map((_, i) => (
              <button
                key={i}
                onClick={() => {
                  setPaused(true);
                  setIndex(i);
                  setTimeout(() => setPaused(false), 2000);
                }}
                className={`h-2.5 w-2.5 rounded-full transition
                ${i === index
                    ? "bg-white scale-125"
                    : "bg-white/40 hover:bg-white/70"
                  }`}
              />
            ))}
          </div>
        </div>

        {/* RIGHT FORM SECTION */}
        <div className="w-full md:w-1/2 flex justify-center">
          <div className="w-full overflow-y-auto hide-scrollbar bg-gradient-to-b from-secondary-50 via-secondary-100 to-secondary-200 rounded-3xl shadow-sm">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};


